import { render } from "./ReverseSSHSetupInstructions.vue?vue&type=template&id=35b65cba"
import script from "./ReverseSSHSetupInstructions.vue?vue&type=script&lang=js"
export * from "./ReverseSSHSetupInstructions.vue?vue&type=script&lang=js"

import "./ReverseSSHSetupInstructions.vue?vue&type=style&index=0&id=35b65cba&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__